import React, { useState } from 'react';
import { Grid, Paper, Button, Snackbar } from '@mui/material';
import ListItemText from "@mui/material/ListItemText";
import makeStyles from '@mui/styles/makeStyles';
import MuiAlert from "@mui/material/Alert";
import OTPInput from 'react-otp-input';
import { BASE_URL_API } from "../Const";
import { MessengerUserRepository } from "../Repository/messenger/MessengerUserRepository";
import { UserRepository } from "../Repository/UserRepository";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const useStyles = makeStyles(() => ({
    paperStyle: {
        padding: 40,
        height: '70vh',
        width: 380,
        margin: "20px auto",
        backgroundColor: '#ffffff',
        borderRadius: '12px',
    },
    headerStyle: {
        marginBottom: '20px',
    },
    logo: {
        width: 96,
        height: 96,
        objectFit: 'contain',
        marginBottom: 8,
    },
    btnStyle: {
        marginTop: 24,
        backgroundColor: '#FF1744',
        color: 'white',
        padding: '12px 0',
        fontWeight: 'bold',
        fontSize: '16px',
    },
    inputField: {
        width: '68px',
        height: '56px',
        fontSize: '28px',
        borderRadius: '10px',
        border: '2px solid #FF1744',
        backgroundColor: '#fff',
        textAlign: 'center',
        outline: 'none',
        margin: '0 6px',
        direction: 'ltr',
        transition: 'all 0.2s ease-in-out',
        '&:focus': {
            borderColor: '#d50000',
            boxShadow: '0 0 4px rgba(255, 23, 68, 0.4)',
        },
    },
    otpWrapper: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        marginBottom: '24px',
        marginTop: '12px',
    },
}));

const LoginComponent = () => {
    const [otp, setOtp] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const classes = useStyles();

    const handleChange = (otp) => {
        setOtp(otp);
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        fetch(BASE_URL_API + 'login', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                code: otp,
                temp_user_token: localStorage.getItem("pwa_temp_user_token"),
            }),
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.code === "200") {
                    localStorage.removeItem("pwa_temp_user_token");

                    UserRepository.saveUserToken(result.data.token);
                   // MessengerUserRepository.saveUserToken(result.data.messenger_data.token);
                    UserRepository.saveUser(result.data);
               //     MessengerUserRepository.saveUser(result.data.messenger_data);

                    const pendingShop = localStorage.getItem("pending_shop_key");
                    window.location.assign(pendingShop ? `/${pendingShop}` : "/");
                    localStorage.removeItem("pending_shop_key");
                } else {
                    setMessage(result.message);
                    setOpenSnackbar(true);
                }
            });
    };

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            style={{ height: '100vh', backgroundColor: '#f7f7f7' }}>

            <Paper elevation={10} style={{width:'300px'}} className={classes.paperStyle} >
                <Grid align="center" className={classes.headerStyle}>
                    <img alt="logo" className={classes.logo} src="/hamekara-logo.png" />
                    <ListItemText
                        style={{ fontWeight: 'bold', fontSize: '20px' }}
                        primary="ورود به همه کارا"
                    />
                </Grid>

                <form onSubmit={handleSubmit} dir="ltr">
                    <div className={classes.otpWrapper}>
                        <OTPInput
                            value={otp}
                            onChange={handleChange}
                            numInputs={6}
                            shouldAutoFocus
                            inputType="tel"
                            renderInput={(props) => (
                                <input {...props} className={classes.inputField} />
                            )}
                        />
                    </div>

                    <Button
                        type="submit"
                        variant="contained"
                        className={classes.btnStyle}
                        fullWidth
                    >
                        ارسال کد
                    </Button>
                </form>
            </Paper>

            <Snackbar
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>

        </Grid>
    );
};

export default LoginComponent;
